import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

const ProtectedRoute = ({ children }) => {
  const { authenticating, loggedIn } = useAuth();
  if (!loggedIn) {
    if (authenticating) {
      return null;
    }
    return <Navigate to="/login" />;
  }
  return children;
};

ProtectedRoute.propTypes = {};

export default ProtectedRoute;
